import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class ForgotPasswordValidator {

    confirmation_email = [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(255),
        Validators.email
    ];

    password = [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(255),
        Validators.pattern('^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])([0-9A-Za-z])+$')
    ];

    confirm_password = [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(255),
        Validators.pattern('^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])([0-9A-Za-z])+$')
    ];

    confirmation_code = [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(6),
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$')
    ];


    // Error messages
    errorMessages = {

        confirmation_code: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'minlength', 
                message: 'MESSAGES.MINIMUM_NUMBER',
                options: { minStr: '6' }
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '6' }
            },
            {
                type: 'pattern', 
                message: 'MESSAGES.CODE_CONFIRMATION',
                options: null
            },
            {
                type: 'mustMatch', 
                message: 'MESSAGES.PASWORD_CONFIRMATION',
                options: null
            }
        ],
        confirmation_email: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'minlength', 
                message: 'MESSAGES.MINIMUM_NUMBER',
                options: { minStr: '5' }
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            },
            {
                type: 'email', 
                message: 'MESSAGES.EMAIL_FORMAT',
                options: null
            }
        ],
        password: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'minlength', 
                message: 'MESSAGES.MINIMUM_NUMBER',
                options: { minStr: '8' }
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            },
            {
                type: 'pattern', 
                message: 'MESSAGES.PASSWORD_PATTERN',
                options: null
            }
        ],
        confirm_password: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'minlength', 
                message: 'MESSAGES.MINIMUM_NUMBER',
                options: { minStr: '8' }
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            },
            {
                type: 'pattern', 
                message: 'MESSAGES.PASSWORD_PATTERN',
                options: null
            },
            {
                type: 'mustMatch', 
                message: 'MESSAGES.PASWORD_CONFIRMATION',
                options: null
            }
        ]
    }
}
